<style lang="stylus" scoped>
@import '../cardMap2.stylus';

.map-card-cont .map-card-lib:nth-child(even) {
  background: #F8F8F8;
}

.map-card {
  border: 1px solid #ccc;
  border-top none;
}

.map-card-cont .map-card-tonnage {
  background: rgba(240, 255, 253, 1) !important;
}
.tabtitle{
  display:flex;
  padding: 20px;
  position absolute;
  flex-direction: row-reverse;
  top 10px;
  right 20px;
  border: 1px solid #ccc;
  border-bottom none;
  width 342px;
  color: rgba(153, 153, 153, 1);
  font-size 15px;
}
</style>
<template>
  <div>
     <div class="tabtitle">
      <div style="width: 140px;text-align: right;">按车辆运营省</div>
      <div  >按车辆注册省</div>
    </div>
    <div class="map-card">
    <div class="map-card-cont" style="top:0;"  v-if="cardItem&&cardItem.length && total>0" >
          <div 
        class="map-card-lib"
        style="margin-top:0;border:0;border-radius:0;"
      >
        <div class="_lib1">合计</div>
        <div class="_lib3">
          <span >{{format(total)}}次</span>
          <span style="width: 140px;text-align: right;display: inline-block;">{{format(total)}}次</span>
        </div>
      </div>
      <div
        class="map-card-lib"
        style="margin-top:0;border:0;border-radius:0;"
        v-for="(it,index) in list"
        :key="index"

      >
        <div class="_lib1">{{it.registProvince}}</div>
        <div class="_lib3">
          <span >{{it.registPathway?it.registPathway:format(it.countNum)+'次'}}</span>
          <span style="width: 140px;text-align: right;display: inline-block;">{{it.registPathway?it.registPathway:format(it.countNum)+'次'}}</span>
        </div>
      </div>
     
    </div>
     <rightBox v-else/>
  </div>
  </div>
  
</template>

<script>
import http from '@/api/cardData'
import Bus from '@/utils/Bus.js'
export default {
  name: 'mapCard',
  data() {
    return {
      cardItemLeth: 0,
      details: {},
      list: []
    }
  },
  props: {
    cardItem: [Array, Object],
    time: Array,
    total: Number
  },
  watch: {
    cardItem: function(value, oldValue) {
      if (this.cardItem.length) {
        let list = this.cardItem.slice(0)
        list.sort((a, b) => {
          return b.countNum * 1 - a.countNum * 1
        })
        this.list = [...list]
      }
    }
  },
  created() {
  },
  mounted() {
    if (this.cardItem.length) {
      let list = this.cardItem
      list.sort((a, b) => {
        return a.countNum * 1 - b.countNum * 1
      })
      this.list = [...list]
    }
  },
  methods: {
    format(num) {
      if (num == -1) {
        return '--'
      } else {
        var reg = /\d{1,3}(?=(\d{3})+$)/g
        return (num + '').replace(reg, '$&,')
      }
    }
  }
}
</script>
